import React, { PureComponent } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import TopNavbar from './TopNavbar';
import { routes } from '../routes';
import LoadingBar from 'react-redux-loading-bar';
import { Helmet } from 'react-helmet';
import queryString from 'query-string';
import * as actions from '../routes/actions/Account';

class WelcomeLayout extends PureComponent {

  componentDidMount() {
    if (!this.props.user.id) {
      this.props.loginRequired(true);
    }
  }

  render() {
    const { user } = this.props;
    const { publicRoutes } = require('../routes');

    if (user.id && this.props.location.pathname === '/') {
      return <Redirect to="/dijitalkitap" />;
    }

    const qs = queryString.parse(this.props.location.search);
    const isNoIndexN = qs.i === 'n';
    const profileRoute = routes[0].routes.find((p) => p.path === '/hesabim');

    return (
      <>
        {isNoIndexN && (
          <Helmet>
            <meta name="robots" content="noindex" />
          </Helmet>
        )}
        <LoadingBar
          style={{ position: 'fixed', zIndex: 99999, width: '100%' }}
        />
        <TopNavbar />
        <Navbar
          light
          hideCategories
          routes={profileRoute.routes}
        />
        <main role="main" className="container mt-2">
          <Switch>
            {publicRoutes.map((route, i) => (
              <Route
                key={i}
                path={route.path}
                exact={!route.routes}
                component={route.component}
              />
            ))}
            <Route path="/">
              <div className="row text-center">
                <div className="col-12 mt-1">
                  <h2>Giriş Yapmanız Gerekiyor.</h2>
                </div>
              </div>
            </Route>
          </Switch>
        </main>
        <Footer light hideTaxonomies />
      </>
    );
  }
}

const mapStateToProps = ({ AccountReducer }) => ({
  user: AccountReducer.user,
});

const mapDispatchToProps = {
  loginRequired: actions.loginRequired,
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
)(WelcomeLayout);